exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._31mxwMPpI44DVWGs6BgMNV{vertical-align:middle;width:14px;height:14px;display:inline-block}", ""]);

// exports
exports.locals = {
	"linkSpinner": "_31mxwMPpI44DVWGs6BgMNV"
};